export const SOCKET_EVENTS = {
  JOB_PROGRESS_STATUS: 'JOB_PROGRESS_STATUS',
  CLEAR_ENV: 'CLEAR_ENV',
  DOWNLOAD_PDF_REPORT: 'DOWNLOAD_PDF_REPORT',
  DOWNLOAD_TL_AI_REPORT: 'DOWNLOAD_TL_AI_REPORT',
  DOWNLOAD_BRIEF: 'DOWNLOAD_BRIEF',
  DOWNLOAD_ASSET_CANDIDATES: 'DOWNLOAD_ASSET_CANDIDATES',
  DOWNLOAD_TI_ASSETS: 'DOWNLOAD_TI_ASSETS',
  NOTIFICATION_CREATED: 'NOTIFICATION_CREATED',
  NOTIFICATION_UPDATED: 'NOTIFICATION_UPDATED',
  NOTIFICATION_DELETED: 'NOTIFICATION_DELETED',
  KAFKA_ASSETS_MGMT_BULK_UPLOAD_STATUS: 'KAFKA_ASSETS_MGMT_BULK_UPLOAD_STATUS',
  RUN_ASM_DISCOVERY: 'RUN_ASM_DISCOVERY',
  TENANT_CONFIGURATION: 'TENANT_CONFIGURATION',
  INITIAL_CREDITS_TRANSFER: 'INITIAL_CREDITS_TRANSFER',
  REFRESH_TOKEN: 'REFRESH_TOKEN',
  RECLAIM_NOTIFICATION: 'RECLAIM_NOTIFICATION'
};

export const PROGRESS_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  ABORTED: 'ABORT',
  TIME_LIMIT: 'TIME_LIMIT'
};

export const JOB_STATUSES = {
  IN_PROGRESS: 'in_progress',
  SUCCESS: 'success',
  DONE: 'done',
  FAILURE: 'failure',
  ABORT: 'abort',
  ABORTED: 'aborted',
  IDLE: 'idle',
  TIME_LIMIT: 'time_limit',
  PENDING: 'pending',
  JOB_STATUSES: 'reached_quota_limit'
};

export const JOB_TO_PROGRESS_STATUS = {
  [JOB_STATUSES.IN_PROGRESS]: PROGRESS_STATUSES.IN_PROGRESS,
  [JOB_STATUSES.SUCCESS]: PROGRESS_STATUSES.SUCCESS,
  [JOB_STATUSES.DONE]: PROGRESS_STATUSES.SUCCESS,
  [JOB_STATUSES.FAILURE]: PROGRESS_STATUSES.FAILURE,
  [JOB_STATUSES.ABORT]: PROGRESS_STATUSES.ABORTED,
  [JOB_STATUSES.ABORTED]: PROGRESS_STATUSES.ABORTED,
  [JOB_STATUSES.TIME_LIMIT]: PROGRESS_STATUSES.TIME_LIMIT
};
